export default __webpack_public_path__ + "static/media/icon-feather-map-pin.d641f712.svg";